import { Stack, Typography } from "@mui/material";
import { IWaitingRoomEmployee } from "src/Pages/Company/Pending/PendingBenefits/types";

export const CellEmployee = ({
  employee,
}: {
  employee: IWaitingRoomEmployee;
}) => (
  <Stack>
    <Typography variant="body2" className="text-truncate">
      {employee.firstName} {employee.lastName}
    </Typography>
    <Typography variant="body2" color="textSecondary" className="text-truncate">
      {employee.fk}
    </Typography>
  </Stack>
);
